/*
 * One product only: keeps its Add to cart / Buy it now buttons and cart quantity
 * in sync with live cart state, without a page reload. The quantity cap itself and
 * the initial disabled state are rendered server-side (Liquid); this only handles
 * updates that happen after page load (AJAX add, drawer removal, quantity change).
 * See snippets/buy-buttons.liquid, sections/main-product.liquid, sections/main-product-pdp.liquid.
 */
class RestrictedProductGuard extends HTMLElement {
  connectedCallback() {
    this.productId = this.dataset.productId;
    this.refresh = this.refresh.bind(this);

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
    document.addEventListener('cart:updated', this.refresh);
    document.addEventListener('ajaxProduct:added', this.refresh);
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    document.removeEventListener('cart:updated', this.refresh);
    document.removeEventListener('ajaxProduct:added', this.refresh);
  }

  refresh() {
    fetch(`${theme.routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => this.applyState(cart))
      .catch((e) => {
        console.error(e);
      });
  }

  applyState(cart) {
    const inCart = cart.items.some((item) => `${item.product_id}` === this.productId);

    document.querySelectorAll(`[data-restricted-product-submit="${this.productId}"]`).forEach((button) => {
      button.disabled = inCart;
      button.toggleAttribute('aria-disabled', inCart);

      const label = inCart ? button.dataset.inCartLabel : button.dataset.defaultLabel;
      if (label) button.textContent = label;
    });

    document.querySelectorAll(`[data-restricted-product-payment="${this.productId}"]`).forEach((wrapper) => {
      wrapper.toggleAttribute('inert', inCart);
    });
  }
}
customElements.define('restricted-product-guard', RestrictedProductGuard);
